import type { CssConstants } from "~/styles/exports/constants"
import values from "~/styles/tokens/colors.json"

export const colors: CssConstants = {
  values,
  toCss: () =>
    Object.entries(values)
      .map(
        ([name, value]) => `$color-${name}: rgb(${value.replace(/, /g, " ")});`,
      )
      .join("\n"),

  toCssGlobal: () => {
    const rootVars = Object.entries(values)
      .map(
        ([name, value]) =>
          `  --color-${name}: rgb(${value.replace(/, /g, " ")});`,
      )
      .join("\n")

    return `:root {\n${rootVars}\n}`
  },
}
